import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "97vh",
    backgroundImage: `url(${"assets/background.jpg"})`,
    overflow: "hidden",
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    padding: "24px",
    borderRadius: "8px",
    boxShadow: tokens.shadow8,
    textAlign: "center",
    maxWidth: "300px",
    width: "70%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  logo: {
    width: "350px",
    marginBottom: "16px",
  },
  buttonSignin: {
    cursor: "pointer",
  },

  loginsuccess: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    padding: "24px",
    fontSize: "20px",
  },
  loginerror: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "50%",
    margin: "0 auto",
    padding: "24px",
    fontSize: "20px",
  },

  placeholderLogo: {
    backgroundColor: "#092a45",
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 0",
  },
  placeholderBody: {
    padding: "0 10px",
  },
  placeholderTitle: {
    fontWeight: "bold",
    fontSize: "14px",
    textDecoration: "underline",
  },
  placeholderDescription: {
    fontSize: "14px",
    margin: "0",
  },
  placeholderButton: {
    backgroundColor: "#E97132",
    color: "#ffffff",
    padding: "8px 16px",
    border: "1px solid #000000",
    borderRadius: "4px",
    fontWeight: "bold",
    cursor: "pointer",
  },
});
